"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_helmet_1 = require("react-helmet");
var Twitter = function (_a) {
    var _b = _a.cardType, cardType = _b === void 0 ? 'summary_large_image' : _b, username = _a.username, title = _a.title, description = _a.description, image = _a.image;
    return (react_1.default.createElement(react_helmet_1.Helmet, null,
        react_1.default.createElement("meta", { name: "twitter:card", content: cardType }),
        username && react_1.default.createElement("meta", { name: "twitter:creator", content: username }),
        title && react_1.default.createElement("meta", { name: "twitter:title", content: title }),
        description && react_1.default.createElement("meta", { name: "twitter:description", content: description }),
        image && react_1.default.createElement("meta", { name: "twitter:image", content: image })));
};
exports.default = Twitter;
//# sourceMappingURL=Twitter.js.map